var _rect, _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 450,
    viewBox: "0 0 800 450",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#2a2a2a"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(400, 200)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 30,
    fill: "none",
    stroke: "#555",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 30,
    fill: "none",
    stroke: "#888",
    strokeWidth: 4,
    strokeDasharray: "47 141",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: 0,
    to: 360,
    dur: "1s",
    repeatCount: "indefinite"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 270,
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fill: "#666",
    textAnchor: "middle"
  }, "Loading...")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingDesktop);
export default __webpack_public_path__ + "static/media/loading-desktop.fc61296b5c9a938377eedea909748ddf.svg";
export { ForwardRef as ReactComponent };